"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButterfly = void 0;
var React = __importStar(require("react"));
var styled_components_1 = require("styled-components");
var IconButterfly = function (props) {
    var theme = styled_components_1.useTheme();
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: !!theme && theme.name === 'purple' ? '#990099' : '#EC008C', fillRule: "evenodd", d: "M17.7627,10.2832 C17.6667,9.2192 17.4197,8.2502 17.0377,7.3582 C17.6897,5.9972 18.3597,5.4922 18.3597,5.4922 C18.3597,5.4922 19.7377,9.0282 18.5287,12.6632 C17.6137,15.4142 16.6637,16.5852 16.2567,16.9922 C17.8457,14.7082 17.9187,12.0162 17.7627,10.2832 M19.7027,14.1332 C19.5277,14.1032 19.1307,14.2372 18.8567,14.5682 C18.2187,15.3392 17.7207,15.9422 16.9457,16.5012 C19.1037,14.2222 21.6827,8.7832 18.5297,3.3572 C18.5297,3.3572 17.3027,4.2072 16.2947,5.9692 C15.3017,4.4342 13.8547,3.1482 12.0557,2.0002 C12.0557,2.0002 7.5017,7.0892 9.5167,14.4592 C3.4367,15.3012 6.0297,20.1862 6.8577,20.4712 C6.8577,20.4712 5.1747,18.3802 7.3997,16.3872 C8.4087,15.4842 10.5257,15.2492 10.5257,15.2492 C10.0447,11.7102 10.0777,8.5122 12.4897,4.9722 C12.7987,5.1782 16.3257,6.7332 16.4587,11.9692 C16.7537,15.2522 15.0537,17.8812 13.4037,18.9032 C10.5517,20.4362 7.4187,21.2052 3.9997,22.0002 C10.5207,21.9762 16.9307,18.7682 19.4787,15.7372 C20.3107,14.7472 19.9277,14.1742 19.7027,14.1332" })));
};
exports.IconButterfly = IconButterfly;
exports.IconButterfly.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconButterfly;
